import {API} from "@/plugins/finAmplifyModules"

/**
 * Class to handle subscriptions.
 */
export class SubscriptionManager {
  constructor() {
    // all registered subscriptions
    this.subscriptions = []
    // all registered next events
    this.nextEvents = []
    //all observables
    this.observables = []
  }

  /**
   * Adds a single subscription.
   *
   * @param subscription - the subscription query with placeholders
   * @param trigger - the method to be called on subscription change
   * @param additionalData - the additional data to return e.g. the item for which the subscription is triggered
   * @return {SubscriptionManager}
   */
  add(subscription, trigger, additionalData) {
    const hasValidSubscription = subscription && subscription.query
      && API.getGraphqlOperationType(subscription.query) === 'subscription'
    const observable = hasValidSubscription ? API.graphql(subscription) : subscription

    if(!observable.subscribe){
      console.error('invalid subscription', subscription)
      return
    }

    const sub = observable.subscribe({
      next: ({value}) => {
        if (trigger) {
          trigger(value, additionalData)
        }
        this.nextEvents.forEach(nextEvent => nextEvent(value, additionalData))
      },
      error: error => console.error('error creating subscription', error)
    })

    this.observables.push(observable)
    this.subscriptions.push(sub)

    return this
  }

  /**
   * Adds multiple subscriptions.
   *
   * @param list - a list of items for which the subscriptions should be created
   * @param subscriptionBuilder - a function to be called for each item to build a subscription query
   * @param trigger - a function to be called if the subscription event triggers
   */
  addFromList(list, subscriptionBuilder, trigger) {
    if (!list) return

    if (!Array.isArray(list)) {
      list = [list]
    }

    list.forEach(item => {
      this.add(subscriptionBuilder(item), trigger, item)
    })

    return this
  }

  /**
   * Adds a custom event listener. All registered event listeners are called if a subscription triggers.
   *
   * @param nextEvent - the event to be called after the trigger
   */
  onNext(nextEvent) {
    this.nextEvents.push(nextEvent)
  }

  /**
   * Unsubscribes all registered subscriptions.
   */
  clear() {
    this.observables = []
    this.subscriptions.forEach(sub => {
      sub.unsubscribe()
    })
    this.subscriptions = []
  }
}
